function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  id: "DraftIcons",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Desktop-HD",
  transform: "translate(-200.000000, -104.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2",
  transform: "translate(201.000000, 105.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.80952381,0 L36.1904762,0 C38.2944181,0 40,1.71624179 40,3.83333333 L40,42.1666667 C40,44.2837582 38.2944181,46 36.1904762,46 L3.80952381,46 C1.70558191,46 0,44.2837582 0,42.1666667 L0,3.83333333 C0,1.71624179 1.70558191,0 3.80952381,0 Z",
  id: "Rectangle",
  stroke: "#FFFFFF",
  strokeWidth: 1.9047619
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.61904762,5.75 L15.2380952,5.75 C16.2900662,5.75 17.1428571,6.6081209 17.1428571,7.66666667 C17.1428571,8.72521244 16.2900662,9.58333333 15.2380952,9.58333333 L7.61904762,9.58333333 C6.56707667,9.58333333 5.71428571,8.72521244 5.71428571,7.66666667 C5.71428571,6.6081209 6.56707667,5.75 7.61904762,5.75 Z",
  id: "Rectangle",
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(9.523810, 36.416667)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.9047619,0 L19.047619,0 C20.09959,0 20.952381,0.858120896 20.952381,1.91666667 C20.952381,2.97521244 20.09959,3.83333333 19.047619,3.83333333 L1.9047619,3.83333333 C0.852790953,3.83333333 0,2.97521244 0,1.91666667 C0,0.858120896 0.852790953,0 1.9047619,0 Z",
  id: "Rectangle",
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("line", {
  x1: 1.9047619,
  y1: 1.91666667,
  x2: 19.047619,
  y2: 1.91666667,
  id: "Line",
  stroke: "#FF6955",
  strokeWidth: 1.9047619,
  strokeLinecap: "round"
})), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#FFFFFF",
  x: 5.71428571,
  y: 13.4166667,
  width: 28.5714286,
  height: 3.83333333,
  rx: 1.9047619
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#FFFFFF",
  x: 5.71428571,
  y: 19.1666667,
  width: 28.5714286,
  height: 3.83333333,
  rx: 1.9047619
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#FFFFFF",
  x: 5.71428571,
  y: 24.9166667,
  width: 28.5714286,
  height: 3.83333333,
  rx: 1.9047619
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#FF6955",
  x: 5.71428571,
  y: 13.4166667,
  width: 15.2380952,
  height: 3.83333333
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#FF6955",
  x: 5.71428571,
  y: 19.1666667,
  width: 19.047619,
  height: 3.83333333
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#FF6955",
  x: 5.71428571,
  y: 24.9166667,
  width: 9.52380952,
  height: 3.83333333
}))));

function SvgEvaluation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "48px",
    viewBox: "0 0 42 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,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";
export { SvgEvaluation as ReactComponent };